import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "details-filter" }
const _hoisted_2 = { class: "filters" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "form-block form-block--30" }
const _hoisted_5 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_6 = { class: "form-block form-block--30" }
const _hoisted_7 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_8 = { class: "form-block form-block--30" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = {
  key: 0,
  class: ""
}
const _hoisted_11 = {
  class: "",
  style: {"overflow":"auto"}
}
const _hoisted_12 = {
  class: "table table-striped",
  style: {"position":"relative"}
}
const _hoisted_13 = { class: "text-start p-sm" }
const _hoisted_14 = { class: "text-capitalize-first" }
const _hoisted_15 = { class: "text-start p-sm" }
const _hoisted_16 = { class: "text-capitalize-first" }
const _hoisted_17 = { class: "text-start p-sm" }
const _hoisted_18 = { class: "text-capitalize-first" }
const _hoisted_19 = { class: "text-start p-sm" }
const _hoisted_20 = { class: "text-capitalize-first" }
const _hoisted_21 = { class: "text-start p-sm" }
const _hoisted_22 = { class: "text-capitalize-first" }
const _hoisted_23 = { class: "p-sm" }
const _hoisted_24 = { class: "d-flex flex-column" }
const _hoisted_25 = { class: "d-flex align-items-center gap-sm" }
const _hoisted_26 = ["title"]
const _hoisted_27 = { class: "text-secondary" }
const _hoisted_28 = { class: "p-sm" }
const _hoisted_29 = { class: "p-sm" }
const _hoisted_30 = { class: "d-flex flex-column" }
const _hoisted_31 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_32 = { class: "p-sm" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "text-nowrap p-sm" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "text-danger" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "d-flex align-items-center justify-content-between gap-sm" }
const _hoisted_42 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_43 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_LoaderContent = _resolveComponent("LoaderContent")!
  const _component_DealDetailsPopup = _resolveComponent("DealDetailsPopup")!
  const _component_Popup = _resolveComponent("Popup")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    class: "popup__lg",
    title: _ctx.$t('labels.message_logs', {'device_name': _ctx.device?.name}),
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.filters.fromDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.fromDate) = $event)),
                mode: "dateTime",
                "model-modifiers": {string: true},
                is24hr: "",
                masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
              }, {
                default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                  _createElementVNode("input", {
                    class: "form-control form-control-sm",
                    placeholder: _ctx.$t('labels.from_date'),
                    value: inputValue,
                    onFocus: togglePopover,
                    onChange: inputEvents.change
                  }, null, 40, _hoisted_5)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.filters.toDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.toDate) = $event)),
                mode: "dateTime",
                "model-modifiers": {string: true},
                is24hr: "",
                masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
              }, {
                default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                  _createElementVNode("input", {
                    class: "form-control form-control-sm",
                    placeholder: _ctx.$t('labels.to_date'),
                    value: inputValue,
                    onFocus: togglePopover,
                    onChange: inputEvents.change
                  }, null, 40, _hoisted_7)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_LoaderButton, {
                "on-click": _ctx.applyFilters,
                class: "form__btn btn"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('button.apply')), 1)
                ]),
                _: 1
              }, 8, ["on-click"])
            ])
          ])
        ])
      ]),
      _createVNode(_component_LoaderContent, {
        ref: "loader",
        class: "",
        style: {"min-height":"500px"}
      }, {
        default: _withCtx(() => [
          (_ctx.device)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("table", _hoisted_12, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_13, [
                          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('labels.id_date')), 1)
                        ]),
                        _createElementVNode("th", _hoisted_15, [
                          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('labels.status')), 1)
                        ]),
                        _createElementVNode("th", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('labels.type')), 1)
                        ]),
                        _createElementVNode("th", _hoisted_19, [
                          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('labels.message')), 1)
                        ]),
                        _createElementVNode("th", _hoisted_21, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('labels.trade_deal')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedResponse.items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: ""
                        }, [
                          _createElementVNode("td", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _withDirectives((_openBlock(), _createElementBlock("span", {
                                  title: item.log.message.id
                                }, [
                                  _createTextVNode(_toDisplayString(item.log.message.id.substring(0, 8)) + "...", 1)
                                ], 8, _hoisted_26)), [
                                  [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    { hover: true }
                                  ]
                                ]),
                                _cache[5] || (_cache[5] = _createTextVNode()),
                                _createVNode(_component_copy_button, {
                                  value: item.log.message.id
                                }, null, 8, ["value"])
                              ]),
                              _createElementVNode("small", _hoisted_27, _toDisplayString(_ctx.dateHelper.format(item.log.message.created_at)), 1)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_28, _toDisplayString(item.log.message.status), 1),
                          _createElementVNode("td", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`message_log.type.${item.log.message.message_source.trigger}`)) + " - " + _toDisplayString(item.log.bank?.name), 1),
                              (item.log.message.user_agent)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_31, _toDisplayString(_ctx.parseUserAgent(item.log.message.user_agent)), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_32, [
                            (item.log.message.message_source.trigger === 'app_push_notification')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                  _createElementVNode("strong", null, _toDisplayString(item.log.message.message_source.app_push_notification.title), 1),
                                  _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                                  _createTextVNode(" " + _toDisplayString(item.log.message.message_source.app_push_notification.notification), 1)
                                ]))
                              : (item.log.message.message_source.trigger === 'sms')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("strong", null, _toDisplayString(item.log.message.message_source.sms.number), 1),
                                    _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(item.log.message.message_source.sms.message), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(JSON.stringify(item.log.message.message_source)), 1))
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            (!item.notification)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, " n/a "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.notification.errors, (error) => {
                                    return (_openBlock(), _createElementBlock("div", { key: error }, [
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t(`message_log.error.${error}`)), 1)
                                    ]))
                                  }), 128)),
                                  (item.notification.dealId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("span", null, _toDisplayString(item.notification.dealPublicId), 1),
                                            _createVNode(_component_copy_button, {
                                              value: item.notification.dealPublicId
                                            }, null, 8, ["value"])
                                          ]),
                                          _createElementVNode("button", {
                                            onClick: [
                                              _withModifiers(($event: any) => (_ctx.showDealDetails(item.notification.dealId)), ["prevent"]),
                                              _cache[2] || (_cache[2] = () => {})
                                            ],
                                            type: "button",
                                            class: "btn btn-sm"
                                          }, [
                                            _createVNode(_component_svg_icon, { icon: "details" })
                                          ], 8, _hoisted_43)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  (_ctx.paginatedResponse.totalCount > _ctx.paginatedResponse.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[4] || (_cache[4] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.paginatedResponse.totalCount,
                        "per-page": _ctx.paginatedResponse.limit,
                        limit: 20,
                        "prev-text": _ctx.$t('button.back'),
                        "next-text": _ctx.$t('button.next'),
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page", "prev-text", "next-text"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_DealDetailsPopup, { ref: "dealDetailsPopup" }, null, 512)
    ]),
    _: 1
  }, 8, ["title", "onOnClose"]))
}